
import axios from 'axios';
import wx from 'weixin-js-sdk';
import $ from 'jquery';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import {promptMessage,fetch} from '@/api/dataHandling';
import dateFormat from 'vux/src/tools/date/format.js'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
data(){
return {
tel:'',
telvalidate:true,
toastShow:false,
toastTxt:'',
openid:null,
hosCode:'yxcrm'
}
},
components:{
dateFormat ,Toast,Icon, GroupTitle,Flexbox, FlexboxItem,Datetime,XTextarea,XInput,XHeader ,XButton,Group
},
methods:{
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
},
getopenid(code){
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code+"&hosCode="+this.hosCode).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;
}
}

}).catch(function (error) {
promptMessage('提示' +error)
this.lookIf = false;
});
},
telvaite(){
this.tel = this.tel.trim();
if(this.tel){
let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
this.$nextTick(function(){
this.tel = this.tel.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.tel) && this.tel){
this.telvalidate=true;
}else{
this.telvalidate=false;
this.toastShow = true;
this.toastTxt = '电话号码不正确，请核实！';

}
})
}

},

sureClick(){
if(this.tel==''||!this.telvalidate){
promptMessage('提示','手机号码必须输入！', function () {

});
return ;

}

if(this.openid==''||this.openid==null){
promptMessage('提示','OPENID未获取！', function () {

});
return ;
}






axios.get("http://118.122.93.13:8856/crm/system/user/updateUserOpenIdByPhone/"+this.tel+"/"+this.openid).then(response => {


if(response.data.code==0){
promptMessage('提示','注册成功', function () {
});
}else{
promptMessage('提示','注册失败，错误原因'+response.data.msg, function () {
});
}


}).catch(error => {
alert(error);
})
},
},
mounted(){
/*   getken(this.getmsg);*/
var _this = this;

axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)
+'&hosCode=' + this.hosCode).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{




_this.getopenid(_this.$route.query.code)


}
}).catch(function (error) {
promptMessage('提示' +error)

});
}
}



// WEBPACK FOOTER //
// ./src/project/rkw/yxcrmregister.vue